"use client";

import { Button } from "../ui/button";

const locationTags = [
  "اجاره ویلا رامسر",
  "شهرهای شمال",
  "اجاره ویلا چالوس",
  "اجاره ویلا نوشهر",
  "اجاره ویلا تهران",
  "اجاره ویلا مازندران",
  "اجاره ویلا شیراکوه",
  "اجاره ویلا قو",
  "اجاره ویلا رشت",
  "اجاره ویلا سوئیت در کردان",
  "اجاره ویلا سوئیت در تبریز",
  "اجاره ویلا سوئیت در مشهد",
  "اجاره ویلا سوئیت در دماوند",
  "اجاره ویلا سوئیت در کیش",
  "اجاره ویلا سوئیت در لواسان",
  "اجاره ویلا سوئیت در نوشهر",
  "اجاره ویلا سوئیت در رامسر",
  "اجاره ویلا سوئیت در مشهد",
];

const LocationTagsSection = () => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-x-4 gap-y-2.5 max-h-[130px] md:max-h-none overflow-hidden">
      {locationTags.map((tag, index) => (
        <Button
          key={index}
          variant="outline"
          className="rounded-[15px] !bg-white text-xs hover:text-primary-500 border-black-100 hover:border-primary-500 transition-colors"
        >
          {tag}
        </Button>
      ))}
    </div>
  );
};

export default LocationTagsSection;
